const SERVICE_WORKER_URL = `${process.env.PUBLIC_URL}/push-sw.js`;

export const pushSupported = () =>
  typeof navigator !== "undefined" &&
  "serviceWorker" in navigator &&
  typeof window !== "undefined" &&
  "PushManager" in window &&
  "Notification" in window;

/** The browser wants the public key as bytes, the server hands it out as base64url */
export const urlBase64ToUint8Array = (base64Url: string) => {
  const padded = (base64Url + "=".repeat((4 - (base64Url.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(padded);
  return Uint8Array.from(raw, (char) => char.charCodeAt(0));
};

export const getBrowserSubscription = async () => {
  if (!pushSupported()) return null;
  const registration = await navigator.serviceWorker.getRegistration(SERVICE_WORKER_URL);
  return (await registration?.pushManager.getSubscription()) ?? null;
};

export const subscribeBrowser = async (publicKey: string) => {
  await navigator.serviceWorker.register(SERVICE_WORKER_URL);
  const registration = await navigator.serviceWorker.ready;
  return (
    (await registration.pushManager.getSubscription()) ??
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    }))
  );
};

type InvokeApi = (args: any) => Promise<any>;

/** Tells the server this browser should stop receiving the signed-in user's notifications. Never throws. */
export const forgetPushSubscription = async (invokeApi: InvokeApi) => {
  try {
    const subscription = await getBrowserSubscription();
    if (!subscription) return;
    await invokeApi({ endpoint: "/unsubscribePush", data: { endpoint: subscription.endpoint }, silent: true });
  } catch {
    // Signing out must not depend on this
  }
};
